module.exports = __webpack_public_path__ + "static/media/t14@2x.612df65b.png";